export const LOAN_HEDGE_REFERENCES = {
  REQUIRED_HEDGE_ID: "loans.hedgeRequirements.requiredHedgeId",
  NOTIONAL: "loans.hedgeRequirements.notional",
  TERM_MONTHS: "loans.hedgeRequirements.termMonths",
  MAX_CAP_STRIKE: "loans.hedgeRequirements.maxCapStrike",
  PRICING_REQUIREMENTS: "loans.hedgeRequirements.pricingRequirements",
  RATING_REQUIREMENTS: "loans.hedgeRequirements.ratingsRequirements",
  EXTENSIONS: "loans.hedgeRequirements.extensions",
  COLLATERAL_ASSIGNMENT: "loans.hedgeRequirements.collateralAssignment",
  LEGAL_OPINION: "loans.hedgeRequirements.legalOpinion",
  EXECUTION_REQUIRENMENTS: "loans.hedgeRequirements.executionRequirements",
  MISC: "loans.hedgeRequirements.misc"

};
